var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('nav',{staticClass:"current-user-nav"},[(_vm.$parent.currentUser.id)?_c('router-link',{staticClass:"btn btn-warning btn-block",attrs:{"to":{
        name: 'sign_out'
      },"tag":"button"}},[_vm._v("\n      Log Out\n    ")]):_vm._e()],1),_vm._v(" "),_c('p',{staticClass:"text-right"},[_vm._v("\n    PA Admin CMS v."+_vm._s(_vm.$store.getters.appVersion)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c4bb55f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 1271
// module chunks = 1